export default "__VITE_PUBLIC_ASSET__29bfa80b__"